// Potentiel du corner selon le CA prévisionnel annuel HT de la dernière décision (Outil → Commercial → Direction)
export const cornerCategory = (ca) => {
  const v = Number(ca) || 0;
  if (v <= 0) return null;
  if (v <= 240000) return { key: 'petit', label: 'Corner Petit', cls: 'bg-sky-100 text-sky-800 border-sky-300' };
  if (v <= 360000) return { key: 'moyen', label: 'Corner Moyen', cls: 'bg-amber-100 text-amber-800 border-amber-300' };
  return { key: 'grand', label: 'Corner Grand', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' };
};

export const simulationRetainedCa = (sim) =>
  sim?.admin_counter_proposal?.ca_previsionnel_ht || sim?.ca_previsionnel_ht_proposed || sim?.average_hypothesis?.ca_ht_annual || 0;

export const CornerCategoryBadge = ({ ca, testid = 'corner-category-badge' }) => {
  const c = cornerCategory(ca);
  if (!c) return null;
  return (
    <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-bold uppercase tracking-wide ${c.cls}`}
      title={`CA prévisionnel retenu : ${Math.round(Number(ca)).toLocaleString('fr-FR')} € / an`} data-testid={testid}>
      {c.label}
    </span>
  );
};
